<template>
  <div class='YPagination'>
    <el-pagination
      :current-page="pageNum"
      @size-change="SizeChange"
      @current-change="CurrentChange"
      :page-sizes="[5, 10, 25, 50, 100]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="Total">
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: 'YPagination',

  props: {
    pageNum: {
      type: Number,
      default: 1
    },

    pageSize: {
      type: Number,
      default: 10
    },

    Total: {
      type: Number,
      default: 0
    }
  },

  methods: {
    SizeChange (val) {
      this.$emit('SizeChange', val)
    },

    CurrentChange (val) {
      this.$emit('CurrentChange', val)
    }
  }
}
</script>

<style lang='stylus' scoped>
  .YPagination
    text-align center
</style>
